/**
 *  추천 검색 키워드 페이지 이름
 */
export const RECOMMEND_SEARCH_WORD_PAGE_NAME = {
  RECOMMEND_SEARCH_WORD_LIST: '추천 검색 키워드 리스트',
  RECOMMEND_SEARCH_WORD_DETAIL: '추천 검색 키워드 상세',
  RECOMMEND_SEARCH_WORD_COPY: '추천 검색 키워드 복사',
  RECOMMEND_SEARCH_WORD_CREATE: '추천 검색 키워드 등록',
};

/**
 *  추천 검색 키워드 타입
 */
export const RECOMMEND_SEARCH_WORD_TYPE = {
  /**
   *  인기 검색어
   */
  POPULAR_POP: 0,
  /**
   *  검색 화면 - 추천 검색어
   */
  SEARCH_RECOMMEND: 1,
};

/**
 *  추천 검색 키워드 타입 텍스트
 */
export const RECOMMEND_SEARCH_WORD_TYPE_TEXT = {
  [RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP]: '인기 검색어',
  [RECOMMEND_SEARCH_WORD_TYPE.SEARCH_RECOMMEND]: '검색 추천',
};

/**
 *  추천 검색 키워드 타입 SELECT 리스트
 */
export const RECOMMEND_SEARCH_WORD_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP,
    name: RECOMMEND_SEARCH_WORD_TYPE_TEXT[RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP],
  },
  {
    id: RECOMMEND_SEARCH_WORD_TYPE.SEARCH_RECOMMEND,
    name: RECOMMEND_SEARCH_WORD_TYPE_TEXT[RECOMMEND_SEARCH_WORD_TYPE.SEARCH_RECOMMEND],
  },
];

/**
 *  추천 검색 키워드 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_MEMO = 2000;

/**
 *  추천 검색 키워드 아이템 최소 개수
 */
export const MINIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT = {
  /**
   *  검색 화면 - 추천 검색어
   */
  [RECOMMEND_SEARCH_WORD_TYPE.SEARCH_RECOMMEND]: 3,
};

/**
 *  추천 검색 키워드 아이템 최대 개수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT = {
  /**
   *  인기 검색어
   */
  [RECOMMEND_SEARCH_WORD_TYPE.POPULAR_POP]: 10,
  /**
   *  검색 화면 - 추천 검색어
   */
  [RECOMMEND_SEARCH_WORD_TYPE.SEARCH_RECOMMEND]: 10,
};
